import { useQuery } from '@tanstack/react-query';
import { invoiceApi, type StripeInvoice } from '../services/invoiceApi';

export function useInvoices() {
  const query = useQuery({
    queryKey: ['stripe-invoices'],
    queryFn:  () => invoiceApi.list(),
    staleTime: 5 * 60_000,   // 5 min — invoices change rarely
    retry: 1,
  });

  return {
    invoices:  (query.data?.invoices ?? []) as StripeInvoice[],
    isLoading: query.isLoading,
    error:     query.error instanceof Error ? query.error.message : null,
    refetch:   query.refetch,
  };
}
